/**
 * @module store/foundations/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetFoundations, apiDeleteFoundations, apiSetFoundation } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getFoundations = async ({ commit, rootGetters }, { limit, offset }) => {
  commit(types.GET_FOUNDATIONS_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetFoundations(userSession.accessToken.jwtToken, { limit, offset });

      commit(types.GET_FOUNDATIONS_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('Неавторизованный пользователь не может получить список e-mail.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_FOUNDATIONS_ASYNC.FAILURE);
  }
};


/**
 * Action: Delete emails
 *
 * @since Version 1.0.1
 */
const deleteFoundations = async ({ rootGetters }, foundations) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeleteFoundations(userSession.accessToken.jwtToken, foundations);
    } else {
      throw new Error('Неавторизованный пользователь не может получить список ордеров.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Set foundation
 *
 * @since Version 1.0.3
 */
const setFoundation = async ({ rootGetters }, foundation) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetFoundation(userSession.accessToken.jwtToken, foundation);
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию об акциях.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  deleteFoundations,
  getFoundations,
  setFoundation,
};
